<div id="content">
<iframe src="https://datastudio.google.com/embed/reporting/1QcWU-hoWNJvrjKWGT0B0QYff1pNuLw2D/page/gKxd" frameborder="0" style="border:0" allowfullscreen></iframe>
</div>


// WEBPACK FOOTER //
// ./src/app/balances/balance-graph.component.html